import { ElementDistribution } from './element-distribution';

export class FlightDistribution extends ElementDistribution {
  withFlights?: boolean; // Indicates if flights are included in the distribution
  withLandOnly?: boolean; // With flights, also opens the land-only departure (requires Product.landOnly)
}

/**
 * The land-only departure is only opened alongside flights: without flights the
 * distribution is land-only anyway, so a stored withLandOnly=true is meaningless.
 */
export function isLandOnlyEnabled(flight?: FlightDistribution | null): boolean {
  return !!flight?.withFlights && !!flight?.withLandOnly;
}
